import script from "./SidebarItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarItem.vue?vue&type=script&setup=true&lang=js"

import "./SidebarItem.vue?vue&type=style&index=0&id=522958f7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-522958f7"]])

export default __exports__